import is, { isNot } from 'typescript-styled-is'
import styled from '../../../theme'
import MenuElement from './MenuElement'
import { Link } from './index'

const MenuList = styled.ul<IMenuListProps>`
  padding: 0;
  margin: 0;
  list-style-type: none;
  height: 100%;
  max-height: 568px;
  max-height: calc(var(--full) - ${({ size }) => (size ? 110 * size : 110)}px);
  width: 100%;
  ${is('safari')`
    overflow: scroll;
    overflow-x: hidden;
    scrollbar-width: none;
    ::-webkit-scrollbar {
       width: 0px; 
    }
  `}
  
  & > ${MenuElement} {
    ${is('nested')`
      padding: 0 ${({ size }) => (size ? 1.25 * size : 1.25)}em 0 ${({
      size,
    }) => (size ? 1.85 * size : 1.85)}em;
    `}
    ${is('noPadding')`
      padding: 0 ${({ size }) => (size ? 1.25 * size : 1.25)}em 0 0;
    `}
    ${isNot('nested')`
      font-size: ${({ size }) => (size ? 0.875 * size : 0.875)}em;
    `}
  }
  
  ${Link} > li {
    border: 1px solid transparent;
    padding-left: ${({ size }) => (size ? 2.9 * size : 2.9)}em;
    font-size: ${({ size }) => (size ? 14 * size : 14)}px;
    display: flex;
    justify-content: space-between;
    padding-right: ${({ size }) => (size ? size : 1)}em;
    color: #3e3e3e;
    width: 240px;
  }
`

export default MenuList

export interface IMenuListProps {
  nested?: boolean
  noPadding?: boolean
  size?: number
  safari?: boolean
}
